'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { SessionStorage } from '@/lib/utils/session-storage'
import { X } from 'lucide-react'
import Image from 'next/image'
import { useEffect, useState } from 'react'

const textMessages = [
  '50.000 CoolCash',
  'Voucher GIẢM 15%',
  'Hoàn tiền khi mua sắm',
]

export const CoolClubPopOver = () => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(SessionStorage.get('coolclub-popover') ?? true)
    }, 300)

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % textMessages.length)
    }, 5000)
    return () => clearInterval(interval)
  }, [])

  const onClose = () => {
    SessionStorage.set('coolclub-popover', false)
    setIsOpen(false)
  }

  // khi người dùng thao tác, scroll thì ẩn
  useEffect(() => {
    const handleMouseDown = () => {
      SessionStorage.set('coolclub-popover', false)
      setIsOpen(false)
    }

    document.addEventListener('mousedown', handleMouseDown)
    document.addEventListener('scroll', handleMouseDown)

    return () => {
      document.removeEventListener('mousedown', handleMouseDown)
      document.removeEventListener('scroll', handleMouseDown)
    }
  }, [])

  if (!isOpen) return null

  return (
    <div className='absolute -bottom-20 right-1.5 z-50 w-40 rounded-lg bg-light p-2 shadow-2xl'>
      <div
        className='absolute -right-5 -top-4 z-10 h-6 w-16 bg-light'
        style={{ clipPath: 'polygon(45% 30%, 25% 100%, 66% 100%)' }}
      ></div>

      <div>
        <div className='flex items-center justify-between'>
          <Image
            src={ImageHelper.getImageUrlCdn('/image/March2024/mceclip4_81.jpg')}
            alt='suggest'
            width={80}
            height={14}
          />
          <button onClick={onClose}>
            <X className='text-neutral-500' size={16} />
          </button>
        </div>
        <div className='mt-2 overflow-x-hidden text-xs'>
          Đăng ký mới nhận ngay
          <br />
          <p
            className='animate-slide-in-from-right font-bold'
            key={currentTextIndex}
          >
            {textMessages[currentTextIndex]}
          </p>
        </div>
      </div>
    </div>
  )
}
